import {
  SetupArea,
  SetupAreaVersion,
  UpdateSetupAreaVersionRequest,
  useSetupAreaVersionAdminService
} from 'nekst-api';
import {
  AfterSubmitFunc,
  FormTemplate,
  TextArea,
  TextInput,
  useShowContextRequired
} from 'ui-builder';
import React from 'react';
import { SetupAreaVersionStatusDropdown } from '../SetupAreaVersionStatusDropdown';
import { IconButton, IconType, usePopupFormManager } from 'features/nekst-widgets';

export function UpdateVersionForm(props: {
  setupAreaId: number,
  setupAreaVersion: SetupAreaVersion,
  afterSubmitFunc?: AfterSubmitFunc,
}) {
  const setupAreaVersionAdminService = useSetupAreaVersionAdminService();

  return (
    <FormTemplate<UpdateSetupAreaVersionRequest, SetupArea>
      title="Update Version"
      submitFormFunc={async (data) => {
        return await setupAreaVersionAdminService.updateVersion(
          props.setupAreaId,
          props.setupAreaVersion.version,
          data
        );
      }}
      validationSchema={{
        version: {
          type: 'string',
          constraints: {
            required: true,
            minLength: 3,
            maxLength: 30,
            regex: {
              value: /^[a-zA-Z0-9\\-]+$/,
              message: 'Alias must start with a letter and can only contain letters, numbers and dashes.'
            }
          }
        },
        status: {
          type: 'string',
          constraints: {
            required: true
          }
        }
      }}
      initialData={{
        version: props.setupAreaVersion.version,
        status: props.setupAreaVersion.status,
        description: props.setupAreaVersion.description,
      }}
      afterSubmitFunc={props.afterSubmitFunc}
    >
      <TextInput source="version" label="Version" />
      <SetupAreaVersionStatusDropdown source="status" label="Version Status" />
      <TextArea source="description" label="Description" />
    </FormTemplate>
  );
}

export function UpdateVersionFormButton(props: {
  setupAreaId: number,
}) {
  const popupFormManager = usePopupFormManager();

  const { data } = useShowContextRequired<SetupAreaVersion>();

  return (
    <IconButton
      onClick={async () => {
        popupFormManager.openForm(
          <UpdateVersionForm
            setupAreaId={props.setupAreaId}
            setupAreaVersion={data}
          />
        );
      }}
      type={IconType.PENCIL}
    />
  );
}
